var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-screen h-screen text-gray-900",attrs:{"id":"app"}},[_c('Layout',{staticClass:"w-full min-h-full"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }